import { memo, type ReactElement } from 'react';
import { usePortfolioRiskSummaryInputSuspenseQuery } from '../../../../../generated/graphql.tsx';
import type { BacktestingConfiguration } from '../BacktestConfiguration.types.ts';
import RiskSummaryContainer from './RiskSummaryContainer.tsx';

const PortfolioRiskSummary = ({
  backtestingConfig,
}: {
  backtestingConfig: BacktestingConfiguration;
}): ReactElement => {
  const query = usePortfolioRiskSummaryInputSuspenseQuery();

  const btcBenchmark = query.data.assets.feature.find((asset) => asset.symbol === 'BTC');
  if (!btcBenchmark) {
    throw new Error('No BTC benchmark found');
  }
  return <RiskSummaryContainer btcBenchmark={btcBenchmark} backtestingConfig={backtestingConfig} />;
};

export default memo(PortfolioRiskSummary);
